import React, { FC } from 'react';

import MediaVideosItem from '../MediaVideosItem';
import Pagination from '../../Pagination';

import { IMediaVideosContent } from './interfaces';

import './styles.scss';

// news content
const MediaVideosContent: FC<IMediaVideosContent> = ({
  data,
  lang,
  page,
  onNextPrev,
  perPage,
}) => {
  // render
  return (
    <div
      className="media-videos-content">
      <div
        className="media-videos-content--container">
        {data?.items && data?.items.map((item: any, index: number) =>
          <MediaVideosItem
            {...item}
            lang={lang}
            key={index} />)}
      </div>
      
      {data?.meta &&
        <Pagination
          current={page}
          total={Math.ceil(data?.meta.total_count / perPage)}
          setCurrent={onNextPrev} />}
    </div>
  );
};

export default MediaVideosContent;